import uniq from 'lodash/uniq';

class Queue {
  constructor() {
    this.queue = [];
  }

  pushToQueue(id) {
    this.queue = uniq([...this.queue, id]);
  }

  removeFromQueue(id) {
    this.queue = uniq(this.queue.filter((el) => el !== id));
  }
}

export default Queue;
